export {
  ProductSchema,
  ProductListSchema,
  ProductContentSchema,
  VariantSchema,
  MediaSchema,
  ColorSchema,
  BundleSchema,
  AvailabilitySchema,
  DirectionSchema,
  OccasionSchema,
  ProductTypeSchema,
  CatalogQuerySchema,
  CatalogSortSchema,
  type Product,
  type ProductContent,
  type Variant,
  type Media,
  type Color,
  type Bundle,
  type Availability,
  type Direction,
  type Occasion,
  type ProductType,
  type CatalogQuery,
  type CatalogSort,
} from './model/product';
export {
  DIRECTION_LABELS,
  OCCASION_LABELS,
  TYPE_LABELS,
  AVAILABILITY_LABELS,
} from './model/labels';
export {
  findVariant,
  optionAvailability,
  isColorAvailable,
  defaultColorId,
  defaultSize,
  colorName,
  colorTint,
  variantLabel,
  primaryMedia,
  availabilityBadge,
  optionsSummary,
  type VariantSelection,
} from './lib/variants';
export { productHref } from './lib/href';
export { ProductMedia, type ProductMediaProps } from './ui/product-media';
export { ProductCard, type ProductCardProps } from './ui/product-card';
export { VariantPicker, type VariantPickerProps } from './ui/variant-picker';
export {
  SizeAdviceRequestSchema,
  SizeAdviceSchema,
  MEASUREMENT_BOUNDS,
  type SizeAdviceRequest,
  type SizeAdvice,
  type MeasurementKey,
} from './model/size-advice';
export {
  parseCatalogQuery,
  catalogQueryToSearch,
  isCatalogQueryEmpty,
  EMPTY_CATALOG_QUERY,
} from './lib/catalog-query';
export { selectColor, selectSize, purchaseBlocker, type Selection } from './lib/selection';
